export default {
    offer: {
        imgList: [
            "https://s21.lgstatic.com/growth/activity/20220221/1645425253985.png?x-oss-process=style/80",
            "https://s20.lgstatic.com/growth/activity/20220221/1645425266364.png?x-oss-process=style/80"
        ],
        buttonImg: "https://s20.lgstatic.com/growth/activity/20220221/1645425275874.png?x-oss-process=style/80",
        pageId: 'c1tjf',
        buttonName: '无门槛免费入群',
        qrCodeUrl: 'https://s21.lgstatic.com/growth/activity/20220221/1645429997997.png?x-oss-process=style/80'
    },
    operate: {
        imgList: [
            "https://s20.lgstatic.com/growth/activity/20220221/1645425301077.png?x-oss-process=style/80",
            "https://s21.lgstatic.com/growth/activity/20220221/1645425313321.png?x-oss-process=style/80"
        ],
        buttonImg: "https://s21.lgstatic.com/growth/activity/20220221/1645425322869.png?x-oss-process=style/80",
        pageId: 'd1tjg',
        buttonName: '无门槛免费入群',
        qrCodeUrl: 'https://s21.lgstatic.com/growth/activity/20220221/1645430007101.png?x-oss-process=style/80'
    },
    byte: {
        imgList: [
            "https://s21.lgstatic.com/growth/activity/20220221/1645425429229.png?x-oss-process=style/80",
            "https://s21.lgstatic.com/growth/activity/20220221/1645425439938.png?x-oss-process=style/80"
        ],
        buttonImg: "https://s20.lgstatic.com/growth/activity/20220221/1645425449961.png?x-oss-process=style/80",
        pageId: 'e1tjh',
        buttonName: '一键入群',
        qrCodeUrl: 'https://s21.lgstatic.com/growth/activity/20220221/1645430015774.png?x-oss-process=style/80'
    },
}
